const getDefaultState = () => {
  return {
    videoPlayer: true,
    liveState: 1,
    height: document.documentElement.clientHeight || document.body.clientHeight
  }
}
const state = getDefaultState()
const actions = {

}
const mutations = {
  SET_VIDEOPLAYER (state, status) {
    state.videoPlayer = status
  },
  SET_LIVESTATE (state, status) {
    state.liveState = status
  },
  SET_DOMHEIGHT (state, height) {
    state.height = height
  }
}
export default {
  namespaced: true,
  actions,
  mutations,
  state
}
